import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as color from '../../../constants/colors';

import {nameValidation, emailValidation} from '../../../utils/itemValidation';

import DeleteWarning from '../../common/modal/DeleteWarning';

import FlatButton from '../../common/buttons/FlatButton';

import RhinoSelect from '../../common/inputs/RhinoSelect';

import * as commonActionCreators from '../../../actions/common';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, usersActionCreators);


class UserModal extends React.Component {


  constructor(props) {
    super(props);

    let location_ids = [];
    if(this.props.users.modalUser && this.props.users.modalUser.locations.length) {
      for(const loc of this.props.users.modalUser.locations) {
        location_ids.push(loc.id);
      }
    }

    this.state = {
      deleteConfirm: false,
      sendingRequest: false,
      serverError: null,
      userId: this.props.users.modalUser ? this.props.users.modalUser.id : null,
      firstName: this.props.users.modalUser ? this.props.users.modalUser.first_name : '',
      lastName: this.props.users.modalUser ? this.props.users.modalUser.last_name : '',
      email: this.props.users.modalUser ? this.props.users.modalUser.email : '',
      role: this.props.users.modalUser ? this.props.users.modalUser.role : '',
      location: this.props.users.modalUser && this.props.users.modalUser.locations.length > 0 ? this.props.users.modalUser.locations[0].id : '',
      locations: this.props.users.modalUser && this.props.users.modalUser.locations.length > 0 ? location_ids : [],
      transferUser: this.props.users.modalUser ? this.props.users.modalUser.transfer_user : false,
      remoteUser: this.props.users.modalUser ? this.props.users.modalUser.remote_user : false,
      watchUser: this.props.users.watchUser ? this.props.users.modalUser.watch_user : false,
      financeUser: this.props.users.financeUser ? this.props.users.modalUser.finance_user : false,
      passwordResetSent: false,
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        role: '',
        location: '',
      }
    };

    this.roleData = [
      {display: 'Sales Associate', 'value': 'SA'},
      {display: 'Back Office', 'value': 'BO'},
      {display: 'General Manager', 'value': 'GM'},
      {display: 'Vice President', 'value': 'VP'},
      {display: 'System Administrator', 'value': 'SY'},
    ];

    // Value is DB id
    this.locationData = [ 
      { value: 1, display: "Headquarters"},
      { value: 36, display: "Atlanta, GA"},
      { value: 2, display: "Austin, TX"},
      { value: 33, display: "Aventura, FL"},
      { value: 28, display: "Baybrook, TX"},
      { value: 3, display: "Birmingham, AL"},
      { value: 23, display: "Boca Raton, FL"},
      { value: 4, display: "Charleston, SC"},
      { value: 5, display: "Charlotte, NC"},
      { value: 6, display: "Cleveland, OH"},
      { value: 7, display: "Columbus, OH"},
      { value: 8, display: "Dallas, TX"},
      { value: 9, display: "ECJ Luxury"},
      { value: 20, display: "Frisco, TX"},
      { value: 24, display: "Greenville, SC"},
      { value: 25, display: "Houston, TX"},
      { value: 10, display: "Indianapolis, IN"},
      { value: 11, display: "Jacksonville, FL"},
      { value: 12, display: "Kansas City, KS"},
      { value: 34, display: "Milwaukee, WI"},
      { value: 21, display: "New Orleans, LA"},
      { value: 31, display: "Oakbrook, IL"},
      { value: 13, display: "Oklahoma City, OK"},
      { value: 37, display: "Palm Beach, FL"},
      { value: 26, display: "Pittsburgh, PA"},
      { value: 14, display: "Raleigh, NC"},
      { value: 15, display: "Richmond, VA"},
      { value: 32, display: "Rockville, MD"},
      { value: 16, display: "St. Louis, MO"},
      { value: 18, display: "San Antonio, TX"},
      { value: 30, display: "Schaumburg, IL"},
      { value: 29, display: "Troy, MI"},
      { value: 27, display: "Tysons, VA"},
      { value: 19, display: "Virginia Beach, VA"},
      { value: 35, display: "Woodlands, TX"}
    ];
  }

  componentWillUpdate(nextProps, nextState) {

    if(nextProps.users.modalOpen && this.props.users.modalOpen === false) {

      let location_ids = [];
      if(nextProps.users.modalUser && nextProps.users.modalUser.locations.length) {
        for(const loc of nextProps.users.modalUser.locations) {
          location_ids.push(loc.id);
        }
      }

      console.log(nextProps.users.modalUser);

      this.setState({
        deleteConfirm: false,
        sendingRequest: false,
        serverError: null,
        userId: nextProps.users.modalUser ? nextProps.users.modalUser.id : null,
        firstName: nextProps.users.modalUser ? nextProps.users.modalUser.first_name : '',
        lastName: nextProps.users.modalUser ? nextProps.users.modalUser.last_name : '',
        email: nextProps.users.modalUser ? nextProps.users.modalUser.email : '',
        role: nextProps.users.modalUser ? nextProps.users.modalUser.role : '',
        location: nextProps.users.modalUser && nextProps.users.modalUser.locations && nextProps.users.modalUser.locations.length > 0 ? nextProps.users.modalUser.locations[0].id : '',
        locations: nextProps.users.modalUser && nextProps.users.modalUser.locations && nextProps.users.modalUser.locations.length > 0 ? location_ids : [],
        transferUser: nextProps.users.modalUser ? nextProps.users.modalUser.transfer_user : false,
        remoteUser: nextProps.users.modalUser ? nextProps.users.modalUser.remote_user : false,
        watchUser: nextProps.users.modalUser ? nextProps.users.modalUser.watch_user : false,
        financeUser: nextProps.users.modalUser ? nextProps.users.modalUser.finance_user : false,
        passwordResetSent: false,
        errors: {
          firstName: '',
          lastName: '',
          email: '',
          role: '',
          location: '',
        }
      });
    }
  }

  getUserActions() {
    let actions = [];

    actions = [
      <div className={this.props.users.modalUser ? 'userSaveButton' : 'userSaveButton addSaveButton'}>
        <button className={'userModalSave actionButton'} onClick={this.handleSave.bind(this)}>
          Save
        </button>
      </div>,
    ];

    if(this.props.users.modalUser) {
      actions.push(
        <div className='employeeDeleteButton'>
          <FlatButton
            key='delete'
            label='Delete'
            fullWidth={true}
            labelStyle={{fontWeight: '700', color: color.ERROR_RED}}
            onClick={this.toggleDeleteConfirm.bind(this)} />
        </div>
      );
    }
    return actions;
  }

  toggleConfirmDelete(val) {
    this.setState({confirmDelete: !this.state.confirmDelete}, () => {
      this.props.commonModalResize();
    });
  }


  validateAll() {
    
    let firstNameError = nameValidation(this.state.firstName);
    let lastNameError = nameValidation(this.state.lastName);
    let emailError = emailValidation(this.state.email);
    let roleError = this.state.role === '' ? 'Please select a role' : null;
    let locationError = this.state.location === '' ? 'Please select a location' : null;

    this.setState({
      errors: Object.assign({}, this.state.errors, {
        firstName: firstNameError,
        lastName: lastNameError,
        email: emailError,
        role: roleError,
        location: locationError,
      })
    });
    if(
      firstNameError !== null ||
      lastNameError !== null ||
      emailError !== null ||
      roleError !== null ||
      locationError !== null
    ) {
      return false;
    } else {
      return true;
    }
  }

  handleSave(evt) {

    if(evt) { evt.preventDefault(); }

    if(this.validateAll() === true) {

      let user = {
        id: this.state.userId,
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        email: this.state.email,
        role: this.state.role,
        location_id: this.state.location,
        location_ids: this.state.locations,
        transfer_user: this.state.transferUser,
        remote_user: this.state.remoteUser,
        watch_user: this.state.watchUser,
        finance_user: this.state.financeUser,
      }
      this.setState({sendingRequest: true});
      this.props.userSave(user)
      .then((respData) => {

        // Take respData (user object), and update
        let updatedUsers = [];
        if(user.id !== null) {
          for(let i = 0; i < this.props.users.users.length; i++) {
            if(this.props.users.users[i].id == respData.user.id) {
              updatedUsers.push(respData.user);
            } else {
              updatedUsers.push(this.props.users.users[i]);
            }
          }
        } else {
          updatedUsers = this.props.users.users;
          updatedUsers.push(respData.user);
        }
        this.props.usersSave(updatedUsers);

        // Close modal
        this.props.usersModalClose();

        this.setState({
          id: null,
          first_name: '',
          last_name: '',
          email: '',
          role: '',
          location: '',
          transferUser: false,
          remoteUser: false,
          errors: {
            firstName: '',
            lastName: '',
            email: '',
            role: '',
            location: '',
          },
        });

      })
      .catch((errorData) => {
        this.setState({
          sendingRequest: false,
          serverError: errorData.message
        });
      });
    }
  }

  handleDelete(evt) {

    if(evt) { evt.preventDefault(); }

    let user = {
      id: this.props.users.modalUser.id,
    }

    this.setState({sendingRequest: true}, () => {
      this.props.userDelete(user)
      .then((respData) => {

        let updatedUsers = [];
        for(let i = 0; i < this.props.users.users.length; i++) {
          if(this.props.users.users[i].id !== user.id) {
            updatedUsers.push(this.props.users.users[i]);
          }
        }
        this.props.usersSave(updatedUsers);
        this.props.usersModalClose();
      })
      .catch((errorData) => {
        this.setState({
          sendingRequest: false,
          serverError: errorData.message
        });
      });
    });
  }

  changeFirstName(evt) {
    this.setState({firstName: evt.target.value});
  }

  changeLastName(evt) {
    this.setState({lastName: evt.target.value});
  }

  changeEmail(evt) {
    this.setState({email: evt.target.value});
  }

  changeRole(evt) {
    this.setState({role: evt.target.value});
  }

  changeLocation(evt) {
    this.setState({location: evt.target.value});
  }

  addLocation(evt) {
    let locationCode = parseInt(evt.target.value);
    if(!this.state.locations.includes(locationCode)) {
      const currentLocations = this.state.locations;
      currentLocations.push(locationCode);
      this.setState({ locations: currentLocations });
    }
  }

  removeLocation(locationId) {
    let locationCode = parseInt(locationId);
    if(this.state.locations.includes(locationCode)) {
      const currentLocations = [];
      for(const locId of this.state.locations) {
        if(locId !== locationCode) {
          currentLocations.push(locId);
        }
      }
      this.setState({ locations: currentLocations });
    }
  }

  validateFirstName() {
    this.setState({errors: Object.assign({}, this.state.errors, {firstName: nameValidation(this.state.firstName)})});
  }

  validateLastName() {
    this.setState({errors: Object.assign({}, this.state.errors, {lastName: nameValidation(this.state.lastName)})});
  }

  validateEmail() {
    this.setState({errors: Object.assign({}, this.state.errors, {email: emailValidation(this.state.email)})});
  }

  getDeleteActions() {
    return [
      <FlatButton
        key='cancel'
        label='Cancel'
        style={{float:'right'}}
        labelStyle={{fontWeight: '700'}}
        onClick={this.toggleDeleteConfirm.bind(this)} />,
      <FlatButton
        key='confirm'
        label='Delete'
        disabled={this.state.sendingRequest}
        style={{float:'right'}}
        labelStyle={{fontWeight: '700', color: color.ERROR_RED}}
        onClick={this.handleDelete.bind(this)} />,
    ];
  }

  promptDeleteConfirm() {
    let actions = this.getDeleteActions();
    return (
      <div className='DeleteWarning'>
        <div>
          <div className='confirmTitle'>Are you sure?</div>
          <div className='confirmSubtitle'>This can't be undone</div>
        </div>
        <div className='modalActions'>
          {actions.map(action => {
            return action;
          })}
        </div>
      </div>
    );
  }

  toggleDeleteConfirm() {
    this.setState({ deleteConfirm: !this.state.deleteConfirm });
  }

  toggleTransferUser() {
    this.setState({ transferUser: !this.state.transferUser });
  }

  toggleRemoteUser() {
    this.setState({ remoteUser: !this.state.remoteUser });
  }

  toggleWatchUser() {
    this.setState({ watchUser: !this.state.watchUser });
  }

  toggleFinanceUser() {
    this.setState({ financeUser: !this.state.financeUser });
  }

  adminResetPassword() {

    if(!this.props.users.modalUser) {
      return;
    }

    let userData = {
      id: this.props.users.modalUser.id,
    }
    
    this.props.usersAdminPasswordReset(userData)
      .then((respData) => {
        this.setState({ passwordResetSent: true });
        this.props.commonAlert('User password reset');
      })
      .catch((errorData) => {
        this.setState({
          serverError: errorData.message
        });
      });
  }

  isMultiLocation() {
    return this.state.role === 'VP';
  }

  getLocationName(locationId) {
    for(const locObj of this.locationData) {
      if(locObj.value === locationId) {
        return locObj.display;
      }
    }
    return '';
  }

  render() {

    return <div className='UserModal'>
      {this.state.deleteConfirm ? 
        this.promptDeleteConfirm() :
        <div>
          <div className={'modalTitle userTitle'}>{this.state.userId === null ? 'Add User' : 'Edit User'}</div>
          <div className='closeIcon' onClick={this.props.usersModalClose.bind(this)}>
            <div className='closeX'>&times;</div>
          </div>
          <div className='modalBr'>
            <img src='/img/manageusers/iconline_thinlight2.svg' />
          </div>
          {this.state.serverError ? 
            <div className={'modalError hasError'}>{this.state.serverError}</div> :
            <div className={'modalError'}></div>
          }
          <div className='dialogRow'>
            <div className='dialogItem'>
              <input
                value={this.state.firstName} 
                onChange={this.changeFirstName.bind(this)} 
                onBlur={this.validateFirstName.bind(this)}
                errorText={this.state.errors.firstName}
                hintText='Robert'
                placeholder='First Name'
                type='text'
                floatingLabelFocusStyle={{color: color.DD_PURPLE}}
                underlineFocusStyle={{borderColor: color.DD_PURPLE}}
                fullWidth={true} />
            </div>
            <div className='dialogItem'>
              <input
                value={this.state.lastName} 
                onChange={this.changeLastName.bind(this)} 
                onBlur={this.validateLastName.bind(this)}
                errorText={this.state.errors.lastName}
                hintText='Smith'
                placeholder='Last Name'
                type='text'
                floatingLabelFocusStyle={{color: color.DD_PURPLE}}
                underlineFocusStyle={{borderColor: color.DD_PURPLE}}
                fullWidth={true} />
            </div>
          </div>
          <div className='dialogRow'>
            <div className='dialogItem'>
              <input
                value={this.state.email} 
                onChange={this.changeEmail.bind(this)} 
                onBlur={this.validateEmail.bind(this)}
                errorText={this.state.errors.email}
                hintText='example@diamondsdirect.com'
                placeholder='Email'
                type='email'
                floatingLabelFocusStyle={{color: color.DD_PURPLE}}
                underlineFocusStyle={{borderColor: color.DD_PURPLE}}
                fullWidth={true} />
            </div>
            <div className='dialogItem'>
              {this.props.users.modalUser ?
                <button className={'resetPasswordButton secondaryButton'} disabled={this.state.passwordResetSent} onClick={this.adminResetPassword.bind(this)}>Reset Password</button> :
                null
              }
            </div>
          </div>
          <div className='dialogRow'>
            <div className='dialogItem'>
              <select className={this.state.errors.role ? 'modalSelect error' : 'modalSelect'} onChange={(evt) => this.changeRole(evt)}>
                <option value=''>Choose a role</option>
                {this.roleData.map((role, i) => {
                  return <option value={role.value} key={i} selected={this.state.role === role.value}>{role.display}</option>
                })}
              </select>
            </div>
            {this.isMultiLocation() ?
              <div className='dialogItem'>
                <select className={this.state.errors.location ? 'modalSelect error' : 'modalSelect'} onChange={(evt) => this.addLocation(evt)} value=''>
                  <option value=''>Choose a location</option>
                  {this.locationData.map((location, i) => {
                    return <option value={location.value} key={i}>{location.display}</option>
                  })}
                </select>
                <div className='locationResults'>
                  {console.log(this.state.locations)}
                  {this.state.locations && this.state.locations.length ?
                    <div>
                      {this.state.locations.map((location, i) => {
                        return <div key={i} className='locationTag'>
                          <div className='locationTagValue'>
                            <div className='locationValueWrapper'>{this.getLocationName(location)}</div>
                          </div>
                          <div className='locationTagAction' onClick={() => this.removeLocation(location)}>
                            <div className='locationActionWrapper'>&times;</div>
                          </div>
                        </div>;
                      })}
                    </div> :
                    null
                  }
                </div>
              </div> :
              <div className='dialogItem'>
                <select className={this.state.errors.location ? 'modalSelect error' : 'modalSelect'} onChange={(evt) => this.changeLocation(evt)}>
                  <option value='' selected={this.state.location === ''}>Choose a location</option>
                  {this.locationData.map((location, i) => {
                    return <option value={location.value} key={i} selected={this.state.location === location.value}>{location.display}</option>
                  })}
                </select>
              </div>
            }
            <div className='dialogNull'>&nbsp;</div>
          </div>

          <div className='dialogRow'>
            <div className='dialogItem'>
              <div className='transferInput'>
                <input type='checkbox' value={this.state.transferUser} checked={this.state.transferUser} onChange={this.toggleTransferUser.bind(this)} />
              </div>
              <div className='transferLabel'>Transfer User?</div>
            </div>
          </div>

          <div className='dialogRow' style={{ display: 'none' }}>
            <div className='dialogItem'>
              <div className='transferInput'>
                <input type='checkbox' value={this.state.remoteUser} checked={this.state.remoteUser} onChange={this.toggleRemoteUser.bind(this)} />
              </div>
              <div className='transferLabel'>Remote User?</div>
            </div>
          </div>

          <div className='dialogRow'>
            <div className='dialogItem'>
              <div className='transferInput'>
                <input type='checkbox' value={this.state.watchUser} checked={this.state.watchUser} onChange={this.toggleWatchUser.bind(this)} />
              </div>
              <div className='transferLabel'>Watch User?</div>
            </div>
          </div>

          <div className='dialogRow'>
            <div className='dialogItem'>
              <div className='transferInput'>
                <input type='checkbox' value={this.state.financeUser} checked={this.state.financeUser} onChange={this.toggleFinanceUser.bind(this)} />
              </div>
              <div className='transferLabel'>Finance User?</div>
            </div>
          </div>

          <div className={'modalActions employeeActions'}>
            <div className={this.props.users.modalUser ? 'userSaveButton' : 'userSaveButton addSaveButton'}>
              <button className={'userModalSave actionButton'} onClick={this.handleSave.bind(this)}>
                Save
              </button>
            </div>
            {this.props.users.modalUser ?
              <div className='employeeDeleteButton'>
                <FlatButton
                  key='delete'
                  label='Delete'
                  labelStyle={{fontWeight: '700', color: color.ERROR_RED}}
                  onClick={this.toggleDeleteConfirm.bind(this)} />
              </div> :
              null
            }
          </div>
        </div>
      }      
    </div>;
  }
}
export default UserModal;

function mapStateToProps(state) {
  return {
    stores: state.stores,
    users: state.users,
  };
}

export const UserModalContainer = connect(
  mapStateToProps,
  allActionCreators
)(UserModal);